import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import News from "./pages/News";
import Consultants from "./pages/Consultants";
import Contact from "./pages/Contact";
import OrderForm from "./pages/OrderForm";

export default function App() {
  return (
    <BrowserRouter  >
      <div className="max-w-[1200px] mx-auto flex flex-col gap-4">
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/consultants" element={<Consultants />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/order-form" element={<OrderForm />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
